import FormBaseModel from '@cp-models/FormBaseModel';

export default class Module extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'name': 'string',
            'type': 'string',
            'sub_type': 'string',
            'price_type': 'string'
        }
    }

}
